<template>
  <basic-card-horizontal
    :headers="statusCardHeaders"
    :item="statusCardItem"
    v-if="run"
  >
    <template #[`item.status`]="{ item }">
      <v-row dense align="center">
        <v-col cols="5">
          <v-tooltip top v-if="item.missingProps">
            <template v-slot:activator="{ on }">
              <v-chip
                v-if="item.statusColor"
                style="margin: 2px 0px"
                :color="item.statusColor"
                dark
                small
                v-on="on"
              >
                {{ item.translatedStatus }}
              </v-chip>
              <span v-else>{{ item.translatedStatus }}</span>
            </template>
            <span style="font-size: 12px">{{ item.missingProps }}</span>
          </v-tooltip>

          <div v-else>
            <v-chip
              v-if="item.statusColor"
              style="margin: 2px 0px"
              :color="item.statusColor"
              dark
              small
            >
              {{ item.translatedStatus }}
            </v-chip>
            <span v-else>{{ item.translatedStatus }}</span>
          </div>
        </v-col>

        <v-col>
          <div v-if="item.showLoader" class="loader"></div>
        </v-col>
      </v-row>
    </template>

    <template #[`item.progress`]="{ item }">
      <v-row v-if="item.progress">
        <v-col>
          <v-progress-linear
            rounded
            height="18"
            :value="item.progress"
            color="light-blue"
          >
          </v-progress-linear>
        </v-col>
        <v-col cols="3">
          {{ item.progressText }}
        </v-col>
      </v-row>
      <span v-else> </span>
    </template>
  </basic-card-horizontal>
</template>

<script>
import BasicCardHorizontal from "@/components/BasicCardHorizontal";

export default {
  name: "StatusCard",

  components: { BasicCardHorizontal },

  props: {
    run: {},
  },

  data() {
    return {
      statusCardHeaders: [
        { text: this.$t("global.concepts.status"), value: "status" },
        { text: this.$t("global.run.progress"), value: "progress" },
        { text: this.$t("global.run.run-time"), value: "runtime" },
      ],
    };
  },

  computed: {
    statusCardItem() {
      if (!this.run) {
        return;
      }
      let status = this.run?.status;
      let currentTask =
        this.run.currentTask === 0 ? 0 : this.run.currentTask - 1;
      let numTasks = this.run.nrOfTasks;
      let statusColor = null;
      let showLoader = false;
      switch (status) {
        case "SUCCESS":
          statusColor = "green";
          break;
        case "ERROR":
          statusColor = "red";
          break;
        case "WAITING_FOR_DATA":
        case "WAITING_FOR_PROPS":
        case "READY_TO_START":
          statusColor = "gray";
          break;
        case "INIT":
        case "INITIALIZING":
        case "SCHEDULED":
        case "FINALIZING":
        case "COMPUTING":
          showLoader = true;
          break;
      }
      let translatedStatus = this.run.translatedStatus;
      let requestedStatus = this.run.requestedStatus;

      if (requestedStatus === "CANCEL_REQUESTED") {
        if (
          status !== "CANCELLED" &&
          status !== "SUCCESS" &&
          status !== "ERROR"
        ) {
          statusColor = null;
          showLoader = true;
        }
      } else if (requestedStatus === "RUN_REQUESTED") {
        if (status === "READY_TO_START") {
          statusColor = null;
          showLoader = true;
        }
      }

      let missingProps = undefined;
      if (this.run.missingProps) {
        missingProps = JSON.parse(this.run.missingProps).join(", ");
      }

      return {
        status: status,
        isRunning: status === "COMPUTING",
        progress: numTasks ? (100 * currentTask) / numTasks : "",
        progressText:
          currentTask || currentTask == 0 ? currentTask + "/" + numTasks : "",
        translatedStatus: translatedStatus,
        runtime: this.formatRunTime(this.run.runTime),
        statusColor: statusColor,
        showLoader: showLoader,
        missingProps: missingProps,
      };
    },
  },

  methods: {
    formatRunTime(runTime) {
      if (!runTime) return;

      const roundedRunTime = Math.round(runTime);
      const hours = Math.floor(roundedRunTime / 3600);
      const minutes = Math.floor((roundedRunTime % 3600) / 60);
      const seconds = (roundedRunTime % 3600) % 60;

      let formatted = "";
      if (hours > 1) {
        formatted += hours + " " + this.$i18n.t("global.concepts.hours") + " ";
      } else if (hours > 0) {
        formatted += hours + " " + this.$i18n.t("global.concepts.hour") + " ";
      }
      if (minutes > 1) {
        formatted +=
          minutes + " " + this.$i18n.t("global.concepts.minutes") + " ";
      } else if (minutes > 0) {
        formatted +=
          minutes + " " + this.$i18n.t("global.concepts.minute") + " ";
      }
      if (seconds > 1 || seconds === 0) {
        formatted += seconds + " " + this.$i18n.t("global.concepts.seconds");
      } else if (seconds > 0) {
        formatted += seconds + " " + this.$i18n.t("global.concepts.second");
      }

      return formatted;
    },
  },
};
</script>
